import { FIELD_PATH_SEPARATOR } from './form-view';
export const isEmptyInputValue = (value)=>value === undefined || value === null || value === '';
const isNested = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
const fill = (values, [key, ...rest], text)=>{
    const current = values[key];
    if (rest.length === 0) {
        return isEmptyInputValue(current) ? {
            ...values,
            [key]: text
        } : values;
    }
    if (!isEmptyInputValue(current) && !isNested(current)) {
        return values;
    }
    const nested = isNested(current) ? current : {};
    const filled = fill(nested, rest, text);
    return filled === nested ? values : {
        ...values,
        [key]: filled
    };
};
const read = (values, [key, ...rest])=>{
    const current = values[key];
    if (rest.length === 0) {
        return current;
    }
    return isNested(current) ? read(current, rest) : undefined;
};
export const mergePrehydrationValues = (values, pending)=>{
    let result = values;
    for (const [path, text] of pending){
        result = fill(result, path.split(FIELD_PATH_SEPARATOR), text);
    }
    return result;
};
export const prunePrehydrationValues = (values, pending)=>{
    for (const path of pending.keys()){
        if (!isEmptyInputValue(read(values, path.split(FIELD_PATH_SEPARATOR)))) {
            pending.delete(path);
        }
    }
};
export const forgetPrehydrationValues = (pending, previousValues, nextValues)=>{
    for (const path of pending.keys()){
        const segments = path.split(FIELD_PATH_SEPARATOR);
        if (read(previousValues, segments) !== read(nextValues, segments)) {
            pending.delete(path);
        }
    }
};

//# sourceMappingURL=prehydration-values.js.map